/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedRelatedPages_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly relatedPages: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_links" | "SharedMobileLinksBlock_links" | "SharedAmpLinksBlock_links">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_itemSearch" | "SharedMobileLinksBlock_itemSearch" | "SharedAmpLinksBlock_itemSearch">;
    readonly " $refType": "SharedRelatedPages_itemSearch";
};
export type SharedRelatedPages_itemSearch$data = SharedRelatedPages_itemSearch;
export type SharedRelatedPages_itemSearch$key = {
    readonly " $data"?: SharedRelatedPages_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedRelatedPages_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedRelatedPages_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relatedPages",
      "storageKey": null,
      "args": null,
      "concreteType": "InternalBuyLinkType",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SharedRespLinksBlock_links",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedMobileLinksBlock_links",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedAmpLinksBlock_links",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedMobileLinksBlock_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedAmpLinksBlock_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '98245bfa08e52df881be5783211db8aa';
export default node;
